const STORAGE_KEY = 'oikos-erp-design-catalog-v1'

/** Senha de acesso ao catálogo ERP — trocar aqui quando necessário. */
const DEFAULT_PASSWORD = 'EcossisERP2026'

export function getErpDesignCatalogPassword() {
  const fromEnv = (process.env.REACT_APP_ERP_DESIGN_CATALOG_PASSWORD || '').trim()
  return fromEnv || DEFAULT_PASSWORD
}

export function isErpDesignCatalogAuthed() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

export function verifyErpDesignCatalogPassword(input) {
  return String(input || '').trim() === getErpDesignCatalogPassword()
}

export function setErpDesignCatalogAuthed() {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1')
  } catch {
    /* ignore */
  }
}

export function clearErpDesignCatalogAuth() {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
